module.exports = __webpack_public_path__ + "media/images/icons/outlined/desktop-8d70f4bf22b13a58978524786791eec0.svg";